<template>
    <div>
      <ts-loading-banner :loading="loadingPreData">
        <form class="form-horizontal mt-3">
          <div class="row">
            <div class="col-md-8">
              <fieldset>
                <legend class="text-black">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.personalContact'
                    )
                  }}
                </legend>
                <div class="row">
                  <div class="col-md-6">
                    <div class="row form-group">
                      <label class="col-md-3 col-form-label">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.studentProfile.phone'
                          )
                        }}
                      </label>
                      <div class="col-md-8">
                        <input
                          type="text"
                          ref="phone"
                          v-model.trim="model.phone"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('phone') }"
                        />
                        <div v-if="errors.has('phone')" class="invalid-feedback">
                          {{ errors.first('phone') }}
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-3 col-form-label">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.studentProfile.email'
                          )
                        }}
                      </label>
                      <div class="col-md-8">
                        <input
                          type="text"
                          v-model.trim="model.email"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('email') }"
                        />
                        <div v-if="errors.has('email')" class="invalid-feedback">
                          {{ errors.first('email') }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row form-group">
                      <label class="col-md-3 col-form-label">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.studentProfile.facebook'
                          )
                        }}
                      </label>
                      <div class="col-md-8">
                        <input
                          type="text"
                          v-model.trim="model.facebook_account"
                          class="form-control"
                          :class="{
                            'is-invalid': errors.has('facebook_account'),
                          }"
                        />
                        <div
                          v-if="errors.has('facebook_account')"
                          class="invalid-feedback"
                        >
                          {{ errors.first('facebook_account') }}
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-3 col-form-label">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.studentProfile.linkIn'
                          )
                        }}
                      </label>
                      <div class="col-md-8">
                        <input
                          type="text"
                          v-model.trim="model.linked_in"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('linked_in') }"
                        />
                        <div
                          v-if="errors.has('linked_in')"
                          class="invalid-feedback"
                        >
                          {{ errors.first('linked_in') }}
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-3 col-form-label">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.studentProfile.telegram'
                          )
                        }}
                      </label>
                      <div class="col-md-8">
                        <input
                          type="text"
                          v-model.trim="model.telegram"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('telegram') }"
                        />
                        <div
                          v-if="errors.has('telegram')"
                          class="invalid-feedback"
                        >
                          {{ errors.first('telegram') }}
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-3 col-form-label">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.studentProfile.line'
                          )
                        }}
                      </label>
                      <div class="col-md-8">
                        <input
                          type="text"
                          v-model.trim="model.line"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('line') }"
                        />
                        <div v-if="errors.has('line')" class="invalid-feedback">
                          {{ errors.first('line') }}
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-3 col-form-label">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.studentProfile.weChat'
                          )
                        }}
                      </label>
                      <div class="col-md-8">
                        <input
                          type="text"
                          v-model.trim="model.we_chart"
                          class="form-control"
                          :class="{ 'is-invalid': errors.has('we_chart') }"
                        />
                        <div
                          v-if="errors.has('we_chart')"
                          class="invalid-feedback"
                        >
                          {{ errors.first('we_chart') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="col-md-4">
              <fieldset>
                <legend class="text-black">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.emergencyContact'
                    )
                  }}
                </legend>
                <div class="row form-group">
                  <label class="col-md-3 col-form-label">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.contactPerson'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <input
                      type="text"
                      v-model.trim="model.emergency_contact_person"
                      class="form-control"
                      :class="{
                        'is-invalid': errors.has('emergency_contact_person'),
                      }"
                    />
                    <div
                      v-if="errors.has('emergency_contact_person')"
                      class="invalid-feedback"
                    >
                      {{ errors.first('emergency_contact_person') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-md-3 col-form-label">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.contactRelation'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <input
                      type="text"
                      v-model.trim="model.emergency_contact_relation"
                      class="form-control"
                      :class="{
                        'is-invalid': errors.has('emergency_contact_relation'),
                      }"
                    />
                    <div
                      v-if="errors.has('emergency_contact_relation')"
                      class="invalid-feedback"
                    >
                      {{ errors.first('emergency_contact_relation') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <label class="col-md-3 col-form-label">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.contactPhone'
                      )
                    }}
                  </label>
                  <div class="col-md-8">
                    <input
                      type="text"
                      v-model.trim="model.emergency_contact_phone"
                      class="form-control"
                      :class="{
                        'is-invalid': errors.has('emergency_contact_phone'),
                      }"
                    />
                    <div
                      v-if="errors.has('emergency_contact_phone')"
                      class="invalid-feedback"
                    >
                      {{ errors.first('emergency_contact_phone') }}
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </form>
      </ts-loading-banner>
    </div>
  </template>
  
  <script>
  import { Errors } from 'form-backend-validation'
  import { mapState } from 'vuex'
  
  export default {
    name: 'contact-form',
    props: ['value', 'validate'],
    data() {
      return {
        model: {},
        loadingPreData: false,
        errors: new Errors(),
      }
    },
    mounted() {
      this.$refs.phone.focus()
    },
    async created() {
      this.model = this.value
      this.$refs.phone.focus()
    },
   
    methods: {
   
    },
    watch: {
      validate: {
        handler() {
          this.errors = new Errors(this.validate.errors)
        },
        deep: true,
      },
      clear: function (value) {
        if (value == true) {
          this.model = this.value
        }
      },
    },
  }
  </script>
  